import React, { useState } from "react";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, Row, Spinner, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AccordionSummary, AccordionDetails, Accordion } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import refreshIcon from "../../assets/refresh.png";
import { BsInfoCircle } from "react-icons/bs";
import deleteLogo from "../../assets/delete.png";

const isReadOnly = (service) => {
  if(!service || !Boolean(service?.paymentStatus?.length)) return false;
  return service?.paymentStatus !== 'UNPAID';
}

const ProductSection = ({
  refreshPaymentStatus,
  addServiceToArray,
  reqServices,
  priceModal,
  showPriceModal,
  deleteService,
  updateProduct,
  changePrice,
  closePriceModal,
  bookingServices
}) => {
  function ConfirmationModal({ service, index }) {
    const [tmpPrice, setTmpPrice] = useState(null);
    const [tmpQty, setTmpQty] = useState(null);
    const [tmpName, setTmpName] = useState(null);
    const [theReason, setTheReason] = useState("");
    const [discount, setDiscount] = useState(0);
    const [discountType, setDiscountType] = useState(null);

    const callUpdateProduct = async () => {
      if (!theReason) {
        alert("Please enter the reason for updating the name, quantity, or price of the product.");
        return;
      }
      await updateProduct({
        uniqueId: service.uniqueId,
        id: service.id,
        slug: service.slug,
        name: tmpName ?? service.name,
        variantId: service.variantId,
        variantName: service.variantName,
        unitPrice: tmpPrice || service.unitPrice,
        qty: tmpQty || service.qty,
        reasonOrComment: theReason,
        discountType,
        discountValue: discount
      })
        .then(res => {
          changePrice(index, tmpPrice || service.unitPrice, theReason, tmpQty || service.qty);
          setTmpPrice(null);
          setTmpQty(null);
          setTheReason("");
        })
        .finally(() => closePriceModal());
    };

    return (
      <Modal show={true} onHide={closePriceModal}>
        <Modal.Header>
          <Modal.Title>Edit Product</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ display: "block" }}>
          <p>Confirm the product modification details for {service.slug}?</p>
          <br />
          <span>Customer sees this name while paying</span>
          <div className="change-box">
            <span className="prefix">Name</span>
            <input type="text" placeholder={service?.name ?? "unknown"} value={tmpName || service?.name || null} onChange={e => setTmpName(e.target.value)} />
          </div>

          <br />
          <div className="change-box">
            <span className="prefix">Quantity</span>
            <input
                type="number"
                readOnly={isReadOnly()}
                placeholder={service.qty}
                value={tmpQty || null}
                onChange={(e) => setTmpQty(e.target.value)}
            />
          </div>
          <br />
          <div className="change-box">
            <span className="prefix">USD</span>
            <input readOnly={isReadOnly()} type="number" placeholder={service.unitPrice} value={tmpPrice || null} onChange={e => setTmpPrice(e.target.value)} />
          </div>
          <br />
          <div className="change-box">
            <span className="prefix">Reason</span>
            <input readOnly={isReadOnly()} placeholder="Reason for price/qty change" onChange={e => setTheReason(e.target.value)} />
          </div>
          <br />
          {/*<div className="change-box">*/}
          {/*  <span className="prefix">Discount Type</span>*/}
          {/*  <select onChange={e => setDiscountType(e.target.value)}>*/}
          {/*    <option value="null">Select Discount Type</option>*/}
          {/*    <option value="percent">Percent</option>*/}
          {/*    <option value="amount">Amount</option>*/}
          {/*  </select>*/}
          {/*</div>*/}
          <br />
          {/*<div className="change-box">*/}
          {/*  <span className="prefix">Discount Amount</span>*/}
          {/*  <input placeholder="Reason for price/qty change" onChange={e => setDiscount(e.target.value)} />*/}
          {/*</div>*/}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closePriceModal}>
            Close
          </Button>
          <Button variant="primary" onClick={callUpdateProduct}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Accordion defaultExpanded className="mb-4 rounded-none">
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ background: "#0000000F" }}>
        <Card.Header className="w-100 border-0 bg-transparent ">
          <Row id="cardTitle">
            <Col md={4}>
              Products Section
              <OverlayTrigger
                placement="right"
                delay={{ show: 50, hide: 400 }}
                overlay={
                  <Tooltip
                    style={{
                      background: "black",
                      color: "white",
                      marginLeft: 5,
                      borderRadius: 5
                    }}
                  >
                    Add (or) edit product/services depending on customer needs. Pending unpaid will adjust accordingly.
                  </Tooltip>
                }
              >
                <BsInfoCircle />
              </OverlayTrigger>
            </Col>

            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              <Row className="mr-1">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <span>Refresh Product/Payment Info</span>
                  &nbsp;&nbsp;
                  <img
                    id="refreshPayIcon"
                    alt="refresh"
                    src={refreshIcon}
                    style={{
                      width: "2vw",
                      height: "2vw",
                      objectFit: "contain",
                      cursor: "pointer",
                      transitionDuration: "1s"
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      refreshPaymentStatus();
                    }}
                  />
                </div>
              </Row>
            </Col>
            <Col className="text-right" md={{ span: 4, offset: 4 }}>
              {/* <Button variant="light" style={{ color: 'white', background: '#866BD9' }} onClick={updateAppointment}>
                <span id="btn-text">Add Product</span>
              </Button> */}
              <DropdownButton
                style={{ background: "#866BD9", color: "white" }}
                drop={"up"}
                className="new-dropdown"
                variant="light"
                id="dropdown-basic-button2"
                title="Add Product"
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {bookingServices?.map((service, index) => (
                    <>
                      <Dropdown.Header>{service.title}</Dropdown.Header>
                      {service?.bookingProducts?.map((product, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={e => {
                            e.stopPropagation();
                            addServiceToArray(product);
                          }}
                        >
                          {product.title} (${product?.price})
                        </Dropdown.Item>
                      ))}
                    </>
                  ))}
                </div>
                {/* <Dropdown.Header>STI TESTING</Dropdown.Header>
                {products?.map((product, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={e => {
                      e.stopPropagation();
                      addServiceToArray(product);
                    }}
                  >
                    {product.name} ({product?.slug})
                  </Dropdown.Item>
                ))} */}
              </DropdownButton>
            </Col>
          </Row>
        </Card.Header>
      </AccordionSummary>
      <AccordionDetails>
        <Row className="w-100">
          <Col className="">
            <Card className=" Card-wrap-2 border-0 shadow-none">
              <Card.Body>
                <Table hover>
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>Quantity</th>
                      <th>Unit Price</th>
                      <th>Net Total</th>
                      <th>Payment status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reqServices &&
                      reqServices?.map((service, index) => (
                        <tr key={index}>
                          {priceModal === index && <ConfirmationModal service={service} index={index} />}
                          <td>
                            <div className="input-box input-box--name">
                              <span className="prefix">name: </span>
                              <input
                                  readOnly={isReadOnly(service)}
                                type="text"
                                placeholder="enter product name"
                                value={service.name ?? service.slug ?? "unknown"}
                                onClick={() => showPriceModal(index)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-box">
                              <span className="prefix">x</span>
                              <input type="number" placeholder="1" value={service.qty} onClick={() => showPriceModal(index)} />
                            </div>
                          </td>
                          <td>
                            <div className="input-box">
                              <span className="prefix">$</span>
                              <input readOnly={isReadOnly(service)} type="number" placeholder="0" value={service.unitPrice} onClick={() => showPriceModal(index)} />
                            </div>
                          </td>
                          <td>{`$ ${service.qty * service.unitPrice}`}</td>
                          <td>
                            <div className="input-box">
                              <span className="prefix">{service?.paymentStatus ?? 'UNPAID'}</span>
                            </div>
                          </td>
                          <td>
                            {!isReadOnly(service) && <img
                              onClick={() => deleteService(index, service.uniqueId)}
                              alt="delete"
                              src={deleteLogo}
                              style={{
                                width: "1.5vw",
                                height: "1.5vw",
                                objectFit: "contain",
                                cursor: "pointer"
                              }}
                            />}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </AccordionDetails>
    </Accordion>
  );
};

export default ProductSection;
